import { RouteComponentProps } from "@reach/router";
import { FunctionComponent, lazy } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../shared/ErrorFallback";

const LazyDevLog = lazy(() => import(/* webpackChunkName: "DevLog" */ "./DevLog"));

const DevLogPage: FunctionComponent<RouteComponentProps> = () => {
	return <ErrorBoundary FallbackComponent={ErrorFallback}>
		<LazyDevLog />
	</ErrorBoundary>;
};

export default DevLogPage;